<template>
  <div>Home</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
